<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <EventForm :baseEvent="event" :baseeventName="name" :loading="loading" @submit-requested="submitRequested"></EventForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import EventForm from './EventForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                event: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { EventForm },
        computed:
        {
            ...mapState('events', ['getEventByIdOutput']),
        },
        methods: {
            ...mapActions('events', ['getEventById']),
            ...mapActions('events', ['putEvent']),
            submitRequested(event) {
                this.putEvent(event);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "Events"});
            }
            else {
                this.getEventById(this.$route.query.id);
            }
        },
        watch:
        {
            getEventByIdOutput: function (output) {
                if (!output) {
                    router.push({name: "Events"});
                }
                else {
                    this.event = output;
                    this.loading = false;
                }
            }
        }
    }
</script>